module.exports = __webpack_public_path__ + "static/img/autCt_bg_white_01.e6aa573a.svg";